<ham-modal
    [title]="
        view === 'list'
            ? ('aumico_topal_manage_modal_title' | i18next)
            : view === 'detail'
            ? ((selectedServer$ | async)?.connection?.displayName || ('aumico_topal_manage_modal_title' | i18next))
            : ('aumico_topal_manage_disconnect_confirm_title' | i18next)
    "
    [hideFooter]="true"
    [size]="'lg'"
    (cancel)="onClose()"
>
    <div class="manage-modal-body">
        <!-- ─────────── List view ─────────── -->
        <ng-container *ngIf="view === 'list'">
            <ng-container *ngIf="servers$ | async as servers">
                <p *ngIf="servers.length === 0" class="manage-modal-body__empty">
                    {{ 'aumico_topal_manage_empty' | i18next }}
                </p>

                <ul class="manage-modal-body__tenant-list" *ngIf="servers.length > 0">
                    <li
                        *ngFor="let row of servers; trackBy: trackByConnectionId"
                        class="manage-modal-body__tenant-card"
                        [class.manage-modal-body__tenant-card--warn]="row.needsReAuth"
                        (click)="onSelectServer(row)"
                    >
                        <div class="manage-modal-body__tenant-main">
                            <div class="manage-modal-body__tenant-text">
                                <div class="manage-modal-body__tenant-title">
                                    {{ row.connection.displayName }}
                                </div>
                                <div class="manage-modal-body__tenant-sub">
                                    {{ row.connection.topal?.serverUrl }}
                                </div>
                                <div
                                    class="manage-modal-body__tenant-status"
                                    [class.manage-modal-body__tenant-status--ok]="!row.needsReAuth"
                                    [class.manage-modal-body__tenant-status--warn]="row.needsReAuth"
                                >
                                    <span class="manage-modal-body__status-dot"></span>
                                    {{
                                        row.needsReAuth
                                            ? ('aumico_topal_manage_status_reauth' | i18next)
                                            : ('aumico_integration_status_connected' | i18next)
                                    }}
                                </div>
                            </div>
                            <div class="manage-modal-body__tenant-chevron">›</div>
                        </div>
                    </li>
                </ul>

                <button
                    type="button"
                    class="manage-modal-body__add-tenant"
                    (click)="onAddServer()"
                >
                    <span class="manage-modal-body__add-tenant-icon">+</span>
                    {{ 'aumico_topal_manage_add_server' | i18next }}
                </button>
            </ng-container>
        </ng-container>

        <!-- ─────────── Detail view ─────────── -->
        <ng-container *ngIf="view === 'detail' && selectedServer$ | async as selected">
            <button
                type="button"
                class="manage-modal-body__back"
                (click)="onBackToList()"
            >
                ‹ {{ 'aumico_topal_manage_back_to_list' | i18next }}
            </button>

            <div class="manage-modal-body__detail-header">
                <div>
                    <div class="manage-modal-body__detail-title">{{ selected.connection.displayName }}</div>
                    <div class="manage-modal-body__detail-sub">
                        {{ selected.connection.topal?.serverUrl }}
                    </div>
                    <div
                        class="manage-modal-body__tenant-status"
                        [class.manage-modal-body__tenant-status--ok]="!selected.needsReAuth"
                        [class.manage-modal-body__tenant-status--warn]="selected.needsReAuth"
                    >
                        <span class="manage-modal-body__status-dot"></span>
                        {{
                            selected.needsReAuth
                                ? ('aumico_topal_manage_status_reauth' | i18next)
                                : ('aumico_integration_status_connected' | i18next)
                        }}
                    </div>
                </div>
            </div>

            <!-- Auto match banner: only visible when the auto match was for THIS server. -->
            <ng-container *ngIf="autoMatchBanner$ && (autoMatchBanner$ | async) as banner">
                <div
                    class="manage-modal-body__automatch-banner"
                    [class.manage-modal-body__automatch-banner--running]="banner.kind === 'running'"
                    [class.manage-modal-body__automatch-banner--success]="banner.kind === 'success'"
                    [class.manage-modal-body__automatch-banner--error]="banner.kind === 'error'"
                >
                    <span
                        *ngIf="banner.kind === 'running'"
                        class="manage-modal-body__automatch-spinner"
                    ></span>
                    <span class="manage-modal-body__automatch-text">
                        <ng-container *ngIf="banner.kind === 'running'">
                            {{ 'aumico_topal_automatch_running' | i18next }}
                        </ng-container>
                        <ng-container *ngIf="banner.kind === 'success'">
                            {{
                                'aumico_topal_automatch_success'
                                    | i18next
                                        : {
                                              autoMatched: banner.autoMatched,
                                              notMapped: banner.notMapped
                                          }
                            }}
                            <span
                                *ngIf="banner.errors > 0"
                                class="manage-modal-body__automatch-errors"
                            >
                                {{
                                    'aumico_topal_automatch_partial_errors'
                                        | i18next : { errors: banner.errors }
                                }}
                            </span>
                        </ng-container>
                        <ng-container *ngIf="banner.kind === 'error'">
                            {{ 'aumico_topal_automatch_failed' | i18next }}
                        </ng-container>
                    </span>
                </div>
            </ng-container>

            <hr class="manage-modal-body__divider" />

            <ng-container *ngIf="externalCompaniesState$ | async as external">
                <div *ngIf="external.isLoading" class="manage-modal-body__centered">
                    <div class="manage-modal-body__spinner"></div>
                    <p class="manage-modal-body__paragraph">
                        {{ 'aumico_topal_manage_loading_companies' | i18next }}
                    </p>
                </div>

                <div *ngIf="external.error" class="manage-modal-body__error-message">
                    {{ external.error }}
                </div>

                <div
                    *ngIf="
                        !external.isLoading &&
                        !external.error &&
                        external.connectionId === selected.connection.id
                    "
                    class="manage-modal-body__companies"
                >
                    <div class="manage-modal-body__companies-header">
                        <span class="manage-modal-body__label">
                            {{
                                'aumico_topal_manage_companies_count'
                                    | i18next : { count: external.items.length }
                            }}
                        </span>

                        <div class="manage-modal-body__search">
                            <ham-filter
                                [value]="(searchTerm$ | async) || ''"
                                [placeholder]="'aumico_integration_search_company_placeholder' | i18next"
                                [hasFilterButton]="false"
                                [autoEmit]="true"
                                (filter)="onSearchTermChange($event || '')"
                            ></ham-filter>
                        </div>
                    </div>

                    <ng-container *ngIf="detailRows$ | async as rows">
                        <p
                            *ngIf="rows.length === 0 && (searchTerm$ | async)"
                            class="manage-modal-body__empty"
                        >
                            {{ 'aumico_topal_manage_search_empty' | i18next }}
                        </p>

                        <div
                            *ngIf="rows.length > 0"
                            class="manage-modal-body__companies-scroll"
                        >
                            <table class="manage-modal-body__companies-table">
                                <thead>
                                    <tr>
                                        <th>{{ 'aumico_topal_manage_company_column_topal' | i18next }}</th>
                                        <th>{{ 'aumico_integration_aumico_company_label' | i18next }}</th>
                                        <th class="manage-modal-body__companies-table-action"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let row of rows; trackBy: trackByDetailRow">
                                        <td>{{ row.suggestion.vendorCompany.externalCompanyName }}</td>
                                        <td>
                                            <span *ngIf="row.mappedAumicoCompany; else notMapped">
                                                {{ row.mappedAumicoCompany.name }}
                                            </span>
                                            <ng-template #notMapped>
                                                <span class="manage-modal-body__not-mapped">
                                                    {{ 'aumico_topal_manage_no_mapping' | i18next }}
                                                </span>
                                            </ng-template>
                                        </td>
                                        <td class="manage-modal-body__companies-table-action">
                                            <button
                                                type="button"
                                                class="manage-modal-body__row-edit"
                                                (click)="onEditSingleCompany(row)"
                                            >
                                                {{ 'aumico_button_edit' | i18next }}
                                            </button>
                                            <button
                                                *ngIf="row.mappedAumicoCompanyId"
                                                type="button"
                                                class="manage-modal-body__row-unlink"
                                                (click)="onUnlinkCompany(row)"
                                            >
                                                {{ 'aumico_topal_manage_btn_unlink' | i18next }}
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </ng-container>
                </div>
            </ng-container>

            <div class="manage-modal-body__detail-actions">
                <ham-button
                    variant="red"
                    size="sm"
                    [outline]="true"
                    (buttonClick)="onRequestDisconnect(selected.connection)"
                >
                    {{ 'aumico_topal_manage_btn_disconnect' | i18next }}
                </ham-button>
            </div>
        </ng-container>

        <!-- ─────────── Disconnect confirm ─────────── -->
        <ng-container *ngIf="view === 'confirm_disconnect' && disconnectCandidate as candidate">
            <div class="manage-modal-body__centered">
                <div class="manage-modal-body__warn-icon">!</div>
                <h3 class="manage-modal-body__heading">
                    {{ 'aumico_topal_manage_disconnect_confirm_title' | i18next }}
                </h3>
                <p class="manage-modal-body__paragraph">
                    {{ candidate.displayName }}
                </p>
                <p class="manage-modal-body__paragraph manage-modal-body__paragraph--muted">
                    {{ 'aumico_topal_manage_disconnect_confirm_text' | i18next }}
                </p>

                <div class="manage-modal-body__actions manage-modal-body__actions--centered">
                    <ham-button variant="red" size="sm" (buttonClick)="onConfirmDisconnect()">
                        {{ 'aumico_topal_manage_btn_disconnect' | i18next }}
                    </ham-button>
                    <ham-button
                        variant="primary"
                        size="sm"
                        [outline]="true"
                        (buttonClick)="onCancelDisconnect()"
                    >
                        {{ 'aumico_button_cancel' | i18next }}
                    </ham-button>
                </div>
            </div>
        </ng-container>
    </div>
</ham-modal>
